

    
    <app-compose-mail appendTo='body' style="z-index: 9999999;" ></app-compose-mail>

    <p-table  styleClass="ui-table-cars"   selectionMode="single" [(selection)]="selectedDelegate"  [columns]="cols" [value]="delgates"    #dt>
        <ng-template pTemplate="caption">
            <div class="ui-helper-clearfix" style="text-align: left">
                <button type="button" pButton icon="pi pi-file-o" *ngIf="false" iconPos="left" label="CSV" (click)="dt.exportCSV()" style="margin-right: 0.5em;"></button>
                <button type="button" pButton icon="pi pi-file-excel" *ngIf="false"  iconPos="left" label="EXCEL" (click)="exportExcel()" style="margin-right: 0.5em;" class="btn-def"></button>
                <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" *ngIf="false" label="PDF" (click)="exportPdf()" class="btn-def"></button>
           
    
    
    
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="status('SENT')" *ngIf="selectedDelegate">  Sent</button>
    
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="status('LU')" *ngIf="selectedDelegate">  Lu</button>
    
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="status('FAILUR')" *ngIf="selectedDelegate">  Failur</button>
    
    
                <button mat-raised-button    style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendLinkEBAdge(45)" *ngIf="false">  <mat-icon class="mat-18">email</mat-icon>Send Link EN </button>
    
                <button mat-raised-button   style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendLinkEBAdge(44)" *ngIf="false">  <mat-icon class="mat-18">email</mat-icon>Send Link FR </button>
    
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendLinkEBAdge(46)" *ngIf="selectedDelegate">  <mat-icon class="mat-18">email</mat-icon>REPORT  FR </button>
                <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                (click)="sendLinkEBAdge(47)" *ngIf="selectedDelegate">  <mat-icon class="mat-18">email</mat-icon>POSTPONEMENT  EN</button>
    
                
    
    
                <p-toggleButton [(ngModel)]="loadByOrder" *ngIf="false"  offLabel="ByCompany" onLabel="ByRate"  class="btn-def"
             (onChange)='loadAll()'
             [style]="{'width':'150px','margin-left':'10px'}"></p-toggleButton>  
    
    
    
                <div style="float: right;">   
     
    
                   <span *ngIf="loaded">{{loaded}} Imported From online server</span>
    
                    <button mat-raised-button  style="background: rgb(223, 128, 4);margin-left: 5px; "  
                    (click)="printBadge()">    <mat-icon class="mat-18" *ngIf="selectedDelegate">print</mat-icon> Print Badge </button>
                    <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px;"  
                    (click)="sendEBAdge(43)" *ngIf="selectedDelegate">  <mat-icon class="mat-18">email</mat-icon>Send E-Badge EN </button>
                    <button mat-raised-button  style="background: #E0F2FD;margin-left: 5px; "  
                    (click)="sendEBAdge(42)" *ngIf="selectedDelegate">  <mat-icon class="mat-18">email</mat-icon>Send E-Badge FR </button>
    
                    <span *ngIf="dt.filteredValue"> {{dt.filteredValue.length}} / </span>{{dt.totalRecords}} Delegate
                    
                    <button type="button" *ngIf="false"  pButton icon="pi pi-file" iconPos="left" label="CSV - Selection Only" (click)="dt.exportCSV({selectionOnly:true})"  ></button>
               
                    <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                    <input type="text" pInputText size="50" placeholder="Global Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
                </div>
         
            </div>
           
     
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>
            </tr>
           
         
            <tr>
                <th *ngFor="let col of columns" [ngSwitch]="col.field">
                    <input  pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')">
               
                  </th>
            </tr>
        </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr   [pSelectableRow]="rowData"
         [ngStyle]="{ 'color': rowData.dateImpression ? 'red' : ''}" style="height:34px">
            <!---->
            <td *ngFor="let col of columns"  [ngSwitch]="col.field" pEditableColumn>
            <span *ngSwitchDefault>{{rowData[col.field]}}</span> 
            <span *ngSwitchCase="'entreprise'">
         <span (click)="gotoBadges(rowData.idClient)" [ngStyle]="{'color': rowData.uid ? 'green' : ''}" style=" text-decoration: underline;cursor: pointer;"> {{rowData.entreprise}}  </span>   
            </span>
    
                <p-cellEditor *ngSwitchCase="'note'">
                   
                    <ng-template pTemplate="input">
                        <textarea rows="10" cols="5" pInputTextarea    (keyup)='editNote(rowData)' (blur)='blur(rowData)' [(ngModel)]="rowData.note"></textarea>
                      
                    </ng-template>
                    <ng-template pTemplate="output">
                       {{rowData.note}}  {{rowData.dateImpression |  date}}
                    </ng-template>
                </p-cellEditor>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody" let-columns="columns">
        <tr style="height:34px">
            <td *ngFor="let col of columns">
                <div class="loading-text"></div>
            </td>
        </tr>
    </ng-template>
    </p-table>
    